export default __webpack_public_path__ + "static/media/apps.ca279308.png";